import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconParagraph"><Path d="M20.25 3.75H15.25M9.75 12.25H7.75C5.40279 12.25 3.5 10.3472 3.5 8C3.5 5.65279 5.40279 3.75 7.75 3.75H9.75M9.75 12.25V20.1725M9.75 12.25V3.75M9.75 3.75H15.25M15.25 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconParagraph;
